import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import ReactPlayer from "react-player";
import { Button, Input, Spinner } from "@material-tailwind/react";
import { NewContext } from "../../Context/NewContext";
import {
  get_one_faq,
  update_faq,
  add_faq,
} from "../../Controller/actions";
import Select from "react-select";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Editor from "../../Pages/FAQ/Editor/Editor";
import Zoom from "react-medium-image-zoom";

import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";

const FaqModel = () => {
  const {
    isModalLoading,
    setDeleteUpdateTag,
    deleteUpdateYes,
    handleFileInput,
    setIsModalLoading,
    handleClose,
    handleChange,
    formData,
    open,
    addEditDeleteTag,
    setFormData,
    saveMedia,
    setSaveMedia
  } = useContext(NewContext);

  const [hasMedia, setHasMedia] = useState(false);
  const [removeMediaIndex, setRemoveMediaIndex] = useState([]);
  const [fromMedia, setFromMedia] = useState([]);
  const mediaTypeRef = useRef(null);

  const getDataFunc = async (id) => {
    const { data } = await get_one_faq(id);
    try {
      setFromMedia(data?.media);
      delete data?.media;
      setFormData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (addEditDeleteTag === "update") {
      getDataFunc(formData?._id);
    }
  }, [addEditDeleteTag]);

  useEffect(() => {

    setSaveMedia(0)
    setHasMedia(false)
    setFromMedia([])
    setRemoveMediaIndex([])
  }, [open]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.answerDetails) {
      toast.error("Answer details is required.");
      return;
    }
    if (!formData.question) {
      toast.error("Question is required.");
    }
    setIsModalLoading(true);
    if (hasMedia) {
      let media = [];
      Array.from(Array(saveMedia)).map((element, i) => {
        if (formData?.[`type` + i] === "youtube") {
          media.push({
            type: formData?.[`type` + i],
            url: formData?.[`youtubeUrl` + i],
          });
          delete formData[`youtubeUrl` + i];
        } else if (formData?.[`type` + i] === "video") {
          media.push({
            type: formData?.[`type` + i],
          });
        } else if (formData?.[`type` + i] === "image") {
          media.push({
            type: formData?.[`type` + i],
          });
        }
        delete formData[`type` + i];
      });
      formData.media = media;
    }

    formData.oldMedia = fromMedia
    let createUpdateFAQ;
    setIsModalLoading(true);
    if (addEditDeleteTag === "update") {
      createUpdateFAQ = await update_faq(formData, formData?._id);
    } else {
      createUpdateFAQ = await add_faq({ ...formData });
    }
    setIsModalLoading(false);
    if (createUpdateFAQ) {
      const { message, status } = createUpdateFAQ;
      if (status) {
        toast.success(message);
        handleClose();
        setDeleteUpdateTag(deleteUpdateYes);
        setHasMedia(false);
        setFromMedia([]);
        setSaveMedia(0);
        setRemoveMediaIndex([])
      } else {
        toast.error(message);
      }
    }
    handleClose();
  };

  useEffect(() => {
    if (open && mediaTypeRef.current && mediaTypeRef.current.focusInput) {
      mediaTypeRef.current.focusInput();
    }
  }, [open, mediaTypeRef.current]);

  const handleMediaOpen = () => {
    setSaveMedia(saveMedia + 1);
    setHasMedia(true);
  };

  const handleRemoveMedia = (indexToRemove) => {
    const updatedFormData = { ...formData };
    removeMediaIndex.push(indexToRemove)
    setRemoveMediaIndex(removeMediaIndex)
    Object.keys(updatedFormData).forEach((key) => {
      if (key.includes(`${indexToRemove}`)) {
        delete updatedFormData[key];
        const mediaIndex = key.replace(/[^0-9]/g, '');
        if (updatedFormData[`type${mediaIndex}`] === "video") {
          delete updatedFormData[`${mediaIndex}`];
          delete updatedFormData[`videoPreview${mediaIndex}`];
        } else if (updatedFormData[`type${mediaIndex}`] === "image") {
          delete updatedFormData[`faqImages${mediaIndex}`];
        } else if (updatedFormData[`type${mediaIndex}`] === "youtube") {
          delete updatedFormData[`youtubeUrl${mediaIndex}`];
        }
        // Remove the selected media type
        delete updatedFormData[`type${mediaIndex}`];
        // Add a flag to indicate that the dropdown should be removed
        updatedFormData[`removeDropdown_${mediaIndex}`] = true;
      }

    });
    setFormData(updatedFormData);
  };


  const handleDragEnd = async (result) => {
    if (!result.destination) {
      return;
    }
    const { source, destination } = result;
    if (source.index === destination.index) {
      return;
    }

    // Reorder the data array according to the drag and drop operation
    const newData = Array.from(fromMedia);
    const [movedItem] = newData.splice(source.index, 1);
    newData.splice(destination.index, 0, movedItem);
    setFromMedia(newData);
  };

  // Remove prev item from the UI
  const handleRemovePrevMedia = async (indexToRemove) => {
    try {
      const updatedMedia = [...fromMedia];
      updatedMedia.splice(indexToRemove, 1);
      setFromMedia(updatedMedia);
    } catch (error) {
      toast.error("Failed to delete media item. Please try again later.");
    }
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              maxWidth: "1080px",
              borderRadius: "12px",
            },
          },
        }}
      >
        <DialogTitle id="responsive-dialog-title" className=" text-[#1E1627] ">
          {addEditDeleteTag === "view"
            ? "Details View"
            : addEditDeleteTag === "update"
              ? `Edit FAQ`
              : `Add FAQ`}
        </DialogTitle>
        <DialogContent>
          <div>
            {addEditDeleteTag !== "view" ? (
              <form onSubmit={handleSubmit}>
                <DialogContent>
                  <div className="grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form">
                    <div className="col-span-6 sm:col-span-3">
                      <label
                        htmlFor="name"
                        className="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Question:<span style={{ color: "red" }}>*</span>
                      </label>
                      <div className="mt-1.5 mb-1.5">
                        <Input
                          id="question"
                          placeholder="Enter question"
                          value={formData?.question}
                          name="question"
                          autoComplete="off"
                          onChange={handleChange}
                          required={true}
                          maxLength={100}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="border p-2 mt-1.5 mb-1.5">
                    <div className="grid grid-cols-12 lg:grid-cols-12 gap-5 add-edit-form ">
                      <div className="col-span-12 lg:grid-cols-12 font-medium flex gap-2 items-center">
                        <Button
                          className="inline-flex items-center mr-1 px-5 py-1 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                          type="button"
                          onClick={handleMediaOpen}
                        >
                          <span>Add Media</span>
                        </Button>
                      </div>
                    </div>

                    <DragDropContext onDragEnd={handleDragEnd}>
                      <Droppable droppableId="Images">
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.droppableProps}
                          >
                            {fromMedia?.length > 0 &&
                              fromMedia?.map((media, i) => {
                                return (
                                  <Draggable
                                    key={i}
                                    draggableId={i.toString()}
                                    index={i}
                                  >
                                    {(provided) => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className="mt-5 grid grid-cols-6 lg:grid-cols-6 gap-5 add-edit-form"
                                        key={i}
                                      >
                                        <div className="col-span-6 sm:col-span-3 bg-blue-gray-50 p-2 rounded-md flex items-center justify-between">
                                          <div className="flex items-center gap-2">
                                            {media.type === "youtube" ? (
                                              <ReactPlayer
                                                key={formData?._id}
                                                url={media?.url}
                                                showPreview
                                                controls
                                                loop
                                                width="100%"
                                                height="50%"
                                              />
                                            ) : media.type === "video" ? (
                                              <ReactPlayer
                                                key={formData?._id}
                                                url={media?.url}
                                                showPreview
                                                controls
                                                loop
                                                width="100%"
                                                height="50%"
                                              />
                                            ) : (
                                              <Zoom>
                                                <img
                                                  width={"50%"}
                                                  className="rounded-lg block"
                                                  src={`${media?.url}`}
                                                  alt="media?.url"
                                                />
                                              </Zoom>
                                            )}
                                            <div className="capitalize"></div>
                                          </div>
                                          <div>
                                            <Button
                                              onClick={() =>
                                                handleRemovePrevMedia(i)
                                              }
                                              className="ml-5 inline-flex items-center mr-1 px-2 py-1 bg-red-500 text-white font-medium border border-red-500 hover:bg-red-600 hover:border-red-600 capitalize text-base"
                                              type="button"
                                            >
                                              Delete
                                            </Button>
                                          </div>
                                        </div>
                                      </div>
                                    )}
                                  </Draggable>
                                );
                              })}
                            {provided.placeholder}
                          </div>
                        )}
                      </Droppable>
                    </DragDropContext>

                    {Array.from(Array(saveMedia)).map((element, i) => {
                      const shouldRemoveDropdown =
                        formData[`removeDropdown_${i}`];
                      return (
                        !removeMediaIndex.includes(i) &&
                        (
                          <div
                            className="mt-5 grid grid-cols-12 lg:grid-cols-12 gap-5 add-edit-form "
                            key={i}
                          >
                            <div className="col-span-3 lg:grid-cols-3 ">
                              <label
                                htmlFor={`type${i}`}
                                className="block text-sm font-medium leading-6 text-gray-900"
                              >
                                Select Media Type:
                              </label>
                              <div className="mt-1.5 relative">
                                {
                                  <Select
                                    ref={mediaTypeRef}
                                    id={`type${i}`}
                                    labelledBy="Select Type"
                                    options={[
                                      {
                                        label: "Youtube",
                                        value: "youtube",
                                        name: `type${i}`,
                                      },
                                      {
                                        label: "Video",
                                        value: "video",
                                        name: `type${i}`,
                                      },
                                      {
                                        label: "Image",
                                        value: "image",
                                        name: `type${i}`,
                                      },
                                    ]}
                                    onChange={(e) => {
                                      setFormData({
                                        ...formData,
                                        [e?.name]: e?.value,
                                      });
                                    }}
                                  />
                                }
                              </div>
                            </div>

                            {formData?.["type" + i] === "youtube" && (
                              <div className="col-span-6">
                                <label
                                  htmlFor={`youtubeUrl${i}`}
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Youtube URL:
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="mt-1.5">
                                  <Input
                                    id={`youtubeUrl${i}`}
                                    placeholder="Enter question"
                                    name={`youtubeUrl${i}`}
                                    onChange={handleChange}
                                    required={true}
                                    autoComplete="off"
                                  />
                                </div>
                              </div>
                            )}
                            {formData?.["type" + i] === "video" && (
                              <>
                                <div className="col-span-3">
                                  <label
                                    htmlFor={`video${i}`}
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Video:<span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="mt-1.5">
                                    <input
                                      id={`${i}`}
                                      type="file"
                                      accept="video/*"
                                      name={`video`}
                                      onChange={(e) => handleFileInput(e)}
                                      className="w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500"
                                      required
                                      autoComplete="off"
                                    />
                                  </div>
                                </div>
                                <div className="col-span-3">
                                  <label
                                    htmlFor={`videoPreview${i}`}
                                    className="block text-sm font-medium leading-6 text-gray-900"
                                  >
                                    Video Preview:
                                    <span style={{ color: "red" }}>*</span>
                                  </label>
                                  <div className="mt-1.5">
                                    <input
                                      id={`videoPreview${i}`}
                                      type="file"
                                      accept="image/*"
                                      name={`videoPreview`}
                                      onChange={(e) => handleFileInput(e)}
                                      className="w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500"
                                      required
                                      autoComplete="off"
                                    />
                                  </div>
                                </div>
                              </>
                            )}
                            {formData?.["type" + i] === "image" && (
                              <div className="col-span-6 ">
                                <label
                                  htmlFor={`faqImages${i}`}
                                  className="block text-sm font-medium leading-6 text-gray-900"
                                >
                                  Images (Multiple Files):
                                  <span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="mt-1.5">
                                  <input
                                    id={`faqImages${i}`}
                                    type="file"
                                    accept="image/*"
                                    name={`faqImages`}
                                    onChange={(e) => handleFileInput(e)}
                                    className="w-full border px-3 py-1.5 rounded-[7px] text-sm border-blue-gray-200 focus:border-blue-500"
                                    multiple
                                    required
                                  />
                                </div>
                              </div>
                            )}

                            <div className="col-span-1 mt-7">
                              <Button
                                onClick={() => handleRemoveMedia(i)}
                                className="inline-flex mr-1 px-2 py-1 bg-red-500 text-white border border-red-500 hover:bg-red-600 hover:border-red-600 capitalize text-base"
                                type="button"
                              >
                                Remove
                              </Button>
                            </div>
                          </div>)
                      );
                    })}
                  </div>
                  <div className="col-span-12 sm:col-span-12">
                    <label
                      htmlFor="showStartDate"
                      className="block text-sm font-medium leading-6 text-gray-900 mt-1.5 mb-1.5"
                    >
                      Answer Details:<span style={{ color: "red" }}>*</span>
                    </label>

                    <Editor
                    />
                  </div>
                </DialogContent>
                <div className="flex justify-end mt-2">
                  <Button
                    onClick={handleClose}
                    className="mr-2.5 px-5 py-2.5 bg-white shadow-none text-[#1E3354] font-medium border border-[#75869F] hover:shadow-none capitalize text-base"
                  >
                    <span>Cancel</span>
                  </Button>
                  <Button
                    disabled={isModalLoading}
                    className="flex items-center mr-1 px-5 py-2.5 bg-[#0047FF] shadow-none text-white font-medium border border-[#0047FF] hover:shadow-none capitalize text-base"
                    type="submit"
                  >
                    {isModalLoading && <Spinner className="h-4 w-4" />}
                    <span className={isModalLoading ? "ml-4" : ""}>
                      {addEditDeleteTag === `add` ? `Add` : `Update`}
                    </span>
                  </Button>
                </div>
              </form>
            ) : (
              ""
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default FaqModel;
